<template>
    <div class="examine-notice-detail">
        <div class="examin-notice-box">
            <div class="widthPC-90 margin-x-auto">
                <!-- <div class="fileNo text-right" v-if="baseInfo.fileNo">{{baseInfo.fileNo}}</div> -->
                <table class="detail-table" border="1" cellspacing="0" cellpadding="0">
                    <tr>
                        <th colspan="4">招投标</th>
                    </tr>
                    <tr>
                        <td class="font-bold">项目名称：</td>
                        <td>{{ baseInfo.tenderProjectName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">招标名称：</td>
                        <td>{{ baseInfo.bidSectionName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">招标类型：</td>
                        <td>{{ baseInfo.projectTypeName }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">招标人：</td>
                        <td>{{ baseInfo.projectOwner }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">城市：</td>
                        <td>{{ baseInfo.province + '-' + baseInfo.city + '-' + baseInfo.county || '-' }}</td>
                    </tr>
                    <tr>
                        <td class="font-bold">发布日期：</td>
                        <td>{{ baseInfo.publishDate }}</td>
                    </tr>
                </table>
                <ad :type="2"></ad>
                <div class="detail-content" v-html="baseInfo.richText"></div>
                <!--判断数组长度 -->
                <relatedBy v-if="extend.relatedByProjectCode && extend.relatedByProjectCode.length > 0"
                    :pageTitle="'关联项目'" :pageType="2"
                    :relatedByData="extend.relatedByProjectCode">
                </relatedBy>
                <relatedBy v-if="extend.relatedByCompanyName && extend.relatedByCompanyName.length > 0"
                    :pageTitle="'建设单位（' + baseInfo.projectOwner + '）关联项目'" :pageType="1" :relatedByData="extend.relatedByCompanyName">
                </relatedBy>
            </div>
        </div>
    </div>
</template>

<script>
import relatedBy from '../components/relatedBy';
export default {
    components: {
        relatedBy
    },

    data() {
        return {
            id: this.$route.query.id || null,
            baseInfo: {
                fileNo: '',
                projectName: '',
                projectCode: '',
                approvalUnit: '',
                type: '',
                title: '',
                completionDate: ''
            },
            extend:{}
        }
    },
    created() {

    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            let ajaxUrl = this.$api.common.tenderingBidding.Detail() + '?id=' + this.id;
            this.$axios.get(ajaxUrl).then((res) => {
                console.log('公告数据详情', res);
                if(res.success) {
                    this.baseInfo = res.data || {};
                    this.extend = res.extend || {};
                }else {
                    this.$message.error(res.msg || '获取数据失败');
                }
                this.pageLoading = false;
            }).catch((err) => { });

        }
    }
}
</script>

<style lang="less" scoped>
.examin-notice-box {
    padding: 20px;
    width: 100%;
    background: #fff;
}

.fileNo {
    font-size: 20px;
    color: #666;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;

    th {
        background: #f1f8ff;
        text-align: center;
    }

    th,
    td {
        padding: 10px;
        border: 1px solid #eee;
        min-width: 150px;
    }
}

.detail-content {
    margin-top: 20px;
    padding: 10px;
    line-height: 3;
    border: 1px solid #ebf1f5;
    box-shadow: 0 2px 4px #ebf1f5;
}
</style>